(ns dre.pages.admin.client-download.events
  (:require
   [day8.re-frame.tracing :refer-macros [fn-traced]]
   [dre.fx :as-alias dre.fx]
   [dre.network :as-alias network]
   [dre.pages.admin.client-download.db :refer [init-db]]
   [goog.date :as gdate]
   [goog.string :as gstring]
   [re-frame.core :as rf]
   [superstructor.re-frame.fetch-fx :as-alias fetch-fx]))

(def db-path [:pages :admin :client-download])

; vvv EVENTS vvv

(rf/reg-event-fx
 ::init
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [_ _]
  {:db init-db}))

(rf/reg-event-db
 ::toggle-loading
 [(rf/path db-path)]
 (fn-traced
  [db _]
  (update db :loading? not)))

(rf/reg-event-fx
 ::download-sanofi-csv
 (fn-traced
  [_ _]
  {:fx [[:dispatch [::toggle-loading]]
        [::network/request [{:endpoint :admin/client-download.export-sanofi-csv}
                            {:timeout (* 60 5 1000) ; 5 mins
                             :response-content-type :text
                             :on-success [::download-sanofi-csv-ok]
                             :on-failure [::download-sanofi-csv-nok]}]]]}))

(defn- current-date-string!
  []
  (let [now (gdate/Date.)]
    (str (.getYear now) "-"
         (gstring/format "%02d" (inc (.getMonth now))) "-"
         (gstring/format "%02d" (.getDay now)))))

(rf/reg-event-fx
 ::download-sanofi-csv-ok
 [rf/trim-v]
 (fn-traced
  [_ [{::fetch-fx/keys [response]}]]
  {:fx [[:dispatch [::toggle-loading]]
        [::dre.fx/download {:content (:body response)
                            :filename (str "dre_rwe_tags_" (current-date-string!) ".csv")
                            :mimetype "text/csv"}]]}))

(rf/reg-event-fx
 ::download-sanofi-csv-nok
 [rf/trim-v]
 (fn-traced
  [_ opts]
  {:fx [[:dispatch [::toggle-loading]]
        [:dispatch [::network/default-failure opts]]]}))

; ---

; vvv SUBS vvv

(rf/reg-sub
 ::state
 (fn [db _]
   (get-in db db-path)))

(rf/reg-sub
 ::loading?
 :<- [::state]
 (fn [state _]
   (:loading? state)))
